const colors = {
  purpleMain: '#5522B5',
  black: '#404667',
  stroke: '#ECEDF2',
  white: '#FFF',
  highlighter: '#F7F5FE',
  background: '#FAFAFF',
  grey: '#818793',
  greyLight: '#F4F4F4',
  errorRed: '#F24949',
  errorRedLight: '#FEF2F2',
  purpleBright: '#7F52D4',
  greyBlue: '#94A5B6',
  orange: '#EDA668',
  pink: '#BF1BC2',
  green: '#2FD22C'
}

const borders = {
  primary: `1px solid ${colors.stroke}`
}

const fonts = {
  extraLargePlusSize: '28px',
  extraLargeSize: '24px',
  extraBigSize: '22px',
  bigSize: '20px',
  largePlusSize: '18px',
  largeSize: '16px',
  normalSize: '14px',
  smallSize: '12px'
}
export { colors, borders, fonts }
